import { useEffect } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { Sidebar } from './Sidebar'
import { Header } from './Header'
import { useAuthStore } from '@/store/authStore'
import { fetchPartner } from '@/api/partners'

export function Layout() {
  const location = useLocation()
  const { setPartner, setLoading } = useAuthStore()
  
  // Fetch current partner on mount
  const { data, isLoading, error } = useQuery({
    queryKey: ['partner'],
    queryFn: fetchPartner,
    retry: 1,
  })
  
  console.log('Layout render:', { data, isLoading, error })
  
  useEffect(() => {
    if (data?.partner) {
      setPartner(data.partner)
    } else if (error) {
      setLoading(false)
    }
  }, [data, error, setPartner, setLoading])
  
  // Show full-screen loader only on initial mount before any data
  if (isLoading && !data && !error) {
    return (
      <div className="flex h-screen items-center justify-center bg-cloudflare-navy">
        <div className="flex flex-col items-center gap-4">
          <div className="h-12 w-12 animate-spin rounded-full border-4 border-cloudflare-orange border-t-transparent" />
          <p className="text-white">Loading FlareBase...</p>
        </div>
      </div>
    )
  }

  return (
    <div className="flex h-screen overflow-hidden bg-background">
      <Sidebar />
      <div className="flex flex-1 flex-col overflow-hidden">
        <Header />
        <main className="flex-1 overflow-auto p-6">
          <Outlet />
        </main>
      </div>
    </div>
  )
}
